import type { StreamRequest, UnaryRequest } from '@connectrpc/connect'
import * as Sentry from '@sentry/browser'
import { findEmptyIdFields } from './empty-id'
import { sourceKey } from './sensitive-call'

export type CaptureMessage = typeof Sentry.captureMessage

export function reportEmptyIdRpcWarning(
  req: UnaryRequest | StreamRequest,
  captureMessage: CaptureMessage = Sentry.captureMessage,
) {
  const emptyIdFields = findEmptyIdFields(req.message)
  if (emptyIdFields.length === 0) {
    return emptyIdFields
  }

  const source = req.contextValues?.get(sourceKey)

  captureMessage(`${req.method.name} called with empty ${emptyIdFields.join(', ')}`, {
    level: 'warning',
    tags: {
      'rpc.method': `${req.service.typeName}/${req.method.name}`,
      'rpc.empty_id': emptyIdFields.join(','),
      ...(source ? { source: String(source) } : {}),
    },
    extra: {
      rpcUrl: req.url,
      rpcMethod: req.method.name,
      rpcService: req.service.typeName,
      emptyIdFields,
      ...(source ? { source } : {}),
    },
    fingerprint: ['rpc-empty-id', req.service.typeName, req.method.name, ...emptyIdFields],
  })

  return emptyIdFields
}
